import { Check, CheckCheck, Loader2 } from 'lucide-react';

// Extraído de WhatsAppPanel.jsx (02.3-client.md paso b) -- ya vivía a nivel de módulo ahí
// (`RenderStatusCheck`, ver ese archivo: re-declararlo dentro de WhatsAppPanel en cada render
// desmontaba/remontaba cada ícono en cada tecleo del composer). Usado por WhatsAppChatList
// (último mensaje de cada chat) y WhatsAppChatThread (cada burbuja propia) -- movido a su
// propio archivo en vez de duplicarlo entre los dos.
export default function WhatsAppStatusCheck({ status }) {
  if (status === 'read') return <CheckCheck size={14} style={{ color: '#53bdeb' }} />;
  if (status === 'delivered') return <CheckCheck size={14} style={{ color: '#8696a0' }} />;
  if (status === 'sent') return <Check size={14} style={{ color: '#8696a0' }} />;
  if (status === 'pending') return <Loader2 size={10} style={{ color: '#8696a0', animation: 'spin 1s linear infinite' }} />;
  if (status === 'failed') return <span style={{ color: '#ef4444', fontSize: '10px' }}>⚠️</span>;
  return null;
}
